import { useTheme } from '@mui/material';
import { SVGProps } from 'react';

export const ProfileIconLarge = (props: SVGProps<SVGSVGElement>) => {
  const theme = useTheme();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={40}
      height={46}
      fill="none"
      {...props}
    >
      <path
        fill={theme.palette.action.active}
        d="M20 20a6.556 6.556 0 0 0 6.557-6.557A6.556 6.556 0 0 0 20 6.885a6.556 6.556 0 0 0-6.557 6.558A6.556 6.556 0 0 0 20 20Zm0 3.279c-4.377 0-13.115 2.196-13.115 6.557v1.779a1.5 1.5 0 0 0 1.5 1.5h23.23a1.5 1.5 0 0 0 1.5-1.5v-1.779c0-4.36-8.738-6.557-13.115-6.557Z"
      />
    </svg>
  );
};
